import { Col, Container, Row } from "react-bootstrap"
import { navigateTo } from "../../redux/router/routerActions"
import { useAppDispatch } from "../../redux/store"
import QuickForm from "../../Components/Forms/QuickForm/QuickForm"
import { convertActiveQueryToUrl } from "../../Helpers/Query/queryHelpers";
import useActiveQueryHook from "../../Hooks/UseActiveQuery/useActiveQueryHook";
import { useGetAmenitiesQuery } from "../../services/bClientApi"
import MongoPagination from "../../Components/Pagination/MongoPagination"
import { AmenityType } from "../../Types/amenityTypes"
import AmenityEntry from "../../Components/Amenity/AmenityEntry/AmenityEntry"
import AccessLinkButton from "../../Components/Buttons/AccessLinkButton";

const typeOptions = [
    { value: 'included', text: 'Included' },
    { value: 'paid', text: 'Paid' },
]

export default function AmenitiesPage() {

    const dispatch = useAppDispatch()

    const { activeQuery } = useActiveQueryHook({
        query: {},
        limit: 10,
    })

    const {
        data,
        error,
        isLoading,
    } = useGetAmenitiesQuery({
        amenitiesQuery: activeQuery.query,
        pagination: {
            page: activeQuery.page,
            limit: activeQuery.limit,
        }
    })
    const amenitiesList = data?.docs || []

    const loadPage = (pageParams: { query: any, page: number, limit: number }) => {
        const destination = `/amenities?${convertActiveQueryToUrl(pageParams)}`
        dispatch(navigateTo(destination))
    }

    return (
        <Container>
            <Row>
                <Col>
                    <div className="d-flex justify-content-between align-items-center">
                        <h1>Amenities</h1>
                        <div className="d-flex gap-2">
                            <AccessLinkButton
                                to="/import-amenities"
                                text="Import Amenities"
                                color="success"
                                action="import-amenities"
                            />
                            <AccessLinkButton
                                to="/add-amenity"
                                text="Add New Amenity"
                                color="primary"
                                action="add-amenity"
                            />
                        </div>
                    </div>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    <QuickForm
                        layout={{ xs: 2 }}
                        initialData={{
                            type: activeQuery.query.type,
                            isActive: activeQuery.query.isActive,
                            featured: activeQuery.query.featured,
                            title: activeQuery.query.title,
                        }}
                        fields={[
                            {
                                fieldName: 'title',
                                fieldLabel: 'Title',
                                fieldType: 'text',
                                placeholder: 'Search by title...',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'type',
                                fieldLabel: 'Type',
                                fieldType: 'select',
                                placeholder: '- Select Type -',
                                options: typeOptions,
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'isActive',
                                fieldLabel: 'Active',
                                fieldType: 'select',
                                placeholder: '- All -',
                                options: [
                                    { value: 'true', text: 'Active' },
                                    { value: 'false', text: 'Inactive' },
                                ],
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'featured',
                                fieldLabel: 'Featured',
                                fieldType: 'select',
                                placeholder: '- All -',
                                options: [
                                    { value: 'true', text: 'Featured' },
                                    { value: 'false', text: 'Not Featured' },
                                ],
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                        ]}
                        disabled={isLoading}
                        onSubmit={(values: any) => {
                            const query: any = { ...values }
                            loadPage({
                                query,
                                page: 1,
                                limit: activeQuery.limit
                            })
                        }}
                    />

                    <div className="amenities-list-container">
                        {amenitiesList && amenitiesList.length > 0 ? (
                            <div>
                                {amenitiesList.map((amenity: AmenityType, idx: number) => {
                                    return (
                                        <AmenityEntry
                                            key={`${amenity._id}-${idx}`}
                                            amenityData={amenity}
                                        />
                                    )
                                })}
                            </div>
                        ) : (
                            <div className="text-center p-4">
                                <h5>No amenities found</h5>
                                <p>Try adjusting your search filters or add a new amenity.</p>
                            </div>
                        )}
                    </div>

                    <MongoPagination
                        data={data}
                        loadPage={(pageLoadInfo: { page: number, limit?: number }) => {
                            loadPage({
                                query: activeQuery.query,
                                limit: activeQuery.limit,
                                ...pageLoadInfo
                            })
                        }}
                    />
                </Col>
            </Row>
        </Container>
    )
}
